import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from 'vuex-persist'
import * as apiEvents from "@/store/modules/apiEvents.js";
import * as trackData from "@/store/modules/trackData.js";
import * as notification from "@/store/modules/notification.js";
import * as cart from "@/store/modules/cart.js";


Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  storage: window.localStorage, // or window.sessionStorage or localForage instance.
  reducer: state => ({
    cart: state.cart,
  })
})

export default new Vuex.Store({
  modules: {
    notification,
    apiEvents,
    trackData,
    cart
  },
  state: {},
  plugins: [vuexLocalStorage.plugin]
});
